@if (items.length) {
<div class="mt-2 flex flex-wrap gap-2">
  @for (item of items; track item.id) {
  <div
    class="flex items-center gap-1 rounded-md border border-borderColor bg-white pr-1"
  >
    <button
      type="button"
      class="flex max-w-56 cursor-pointer items-center gap-2 rounded-md bg-white px-2 py-2 text-left transition-colors hover:bg-slate-50 disabled:cursor-default disabled:hover:bg-white"
      [disabled]="item.loading || item.error"
      [pTooltip]="item.filename"
      tooltipPosition="top"
      (click)="onAttachmentClick(item)"
    >
      @if (item.loading) {
      <p-skeleton width="2.5rem" height="2.5rem" borderRadius="6px" />
      } @else if (item.error) {
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-red-50 text-red-600"
      >
        <i class="pi pi-exclamation-circle"></i>
      </span>
      } @else if (item.kind === 'pdf') {
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-red-50 text-red-600"
      >
        <i class="pi pi-file-pdf"></i>
      </span>
      } @else if (item.kind === 'document') {
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-slate-100 text-slate-600"
      >
        <i class="pi pi-file"></i>
      </span>
      } @else {
      <img
        class="h-10 w-10 shrink-0 rounded-md object-cover"
        [src]="item.objectUrl"
        [alt]="item.filename"
      />
      }
      <span class="min-w-0 flex-1 truncate text-xs text-content">
        {{ item.error ? "Attachment unavailable" : item.filename }}
      </span>
    </button>
    @if (allowScan && !item.error && item.kind !== 'document') {
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted transition-colors hover:bg-slate-100 hover:text-content disabled:cursor-default disabled:opacity-50"
      [disabled]="item.loading"
      pTooltip="Scan this document"
      tooltipPosition="top"
      (click)="onScanClick(item)"
    >
      <i class="pi pi-search text-sm"></i>
    </button>
    }
  </div>
  }
</div>
}

<p-dialog
  [(visible)]="imageDialogVisible"
  [header]="selectedImageFilename"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: 'min(900px, 92vw)' }"
>
  @if (selectedImageUrl) {
  <img
    class="max-h-[75vh] w-full object-contain"
    [src]="selectedImageUrl"
    [alt]="selectedImageFilename"
  />
  }
</p-dialog>
